export default __webpack_public_path__ + "static/char-s-50-zh-Hans-c9a2a100af042f68eb7e454cb28a9015.png";